import { faker } from '@faker-js/faker';
import {mockStores} from "./stores";
import {usersList} from "./users";
import {mockScenarios} from "./scenarios";
import {mockRules} from "./rules";
import {mockProducts} from "./products";



let alertIdCounter = 1;

export const generateFakeTransactionsWithAlerts = (count = 1500) => {
    const alerts: any[] = [];
    
    // Calculate date range: last 14 days to today
    const today = new Date();
    const fourteenDaysAgo = new Date();
    fourteenDaysAgo.setDate(today.getDate() - 14);
    
    const transactions = Array.from({ length: count }).map((_, i) => {
        const date = faker.date.between({
            from: fourteenDaysAgo,
            to: today,
        });

        const receiptNumber = faker.string.uuid().slice(0, 8);
        const store = faker.helpers.arrayElement(mockStores);

        const tender_type = faker.helpers.arrayElement([
            "cash",
            "credit_card",
            "foreign_currency",
            "check",
        ]);

        const cashierList = Array.from({ length: 20 }, (_, i) => `${String(i + 1).padStart(3, "0")}`);

        const fullCardNumber = faker.finance.creditCardNumber();
        const last4 = fullCardNumber.slice(-4);
        const maskedCard = `**** **** **** ${last4}`;

        const itemCount = faker.number.int({ min: 1, max: 10 });
        const items = Array.from({ length: itemCount }).map(() => {
            const product = faker.helpers.arrayElement(mockProducts);
            const qty = faker.number.int({ min: 1, max: 5 });
            const unitPrice = product.price;
            const total = parseFloat((qty * unitPrice).toFixed(2));
            const isVoided = faker.datatype.boolean();

            const alertList = isVoided
                ? Array.from({ length: faker.number.int({ min: 1, max: 2 }) }).map(() => {
                    const id = `AL-${store.id.split("ST")[1]}-${String(alertIdCounter++).padStart(5, '0')}`; // e.g., AL00001
                    const scenario = faker.helpers.arrayElement(mockScenarios);
                    const scenarioId = scenario.id;
                    const rule = faker.helpers.arrayElement(mockRules);
                    const ruleId = rule.id ;
                    const scenarioName = scenario.name;
                    const ruleName = rule.name;
                    const status = faker.helpers.arrayElement(['new', 'in_review', 'closed']);
                    const reviewer = faker.helpers.arrayElement(usersList);
                    const reviewedBy = (status === 'in_review' || status === 'closed') ? reviewer.memberName : null;
                    // Review date should be after the transaction date but before today
                    const reviewDate  = reviewedBy ? faker.date.between({
                        from: date, // Review happens after transaction
                        to: today,   // But before today
                    }) : null;
                    const videoUrl = faker.helpers.arrayElement(["video1","video2","video3","video4","video5",null]);

                    const alert = {
                        id: id,
                        receiptNumber,
                        store,
                        scenarioId,
                        scenarioName,
                        ruleId,
                        ruleName,
                        date: date.toLocaleString('tr-TR'),
                        status,
                        reviewedBy,
                        reviewDate : reviewDate ? reviewDate.toLocaleString('tr-TR') : null,
                        videoUrl,
                    };

                    alerts.push(alert);
                    return alert;
                })
                : [];

            return { name: product.name, qty, unitPrice, total, alerts: alertList, isVoided };
        });

        const totalGross = items.reduce((sum, i) => sum + i.total, 0);
        const totalTax = +(totalGross * 0.18).toFixed(2);
        const total = +(totalGross + totalTax).toFixed(2);
        const alertCount = items.reduce((sum, item) => sum + (item.alerts?.length || 0), 0);

        return {
            id: i + 1,
            receiptNumber,
            checkout: faker.helpers.arrayElement([1, 2, 3, 4, 5]),
            cashier: faker.helpers.arrayElement(cashierList),
            storeData: store,
            store: store.name,
            date: date.toLocaleString("tr-TR"),
            items,
            total_gross_amount: `₺${totalGross.toFixed(2)}`,
            total_tax: `₺${totalTax.toFixed(2)}`,
            total: `₺${total.toFixed(2)}`,
            alert_count: alertCount,
            transaction_type: faker.helpers.arrayElement(["sales", "void", "return"]),
            tender_type,
            credit_card: tender_type === "credit_card" ? maskedCard : "",
            duration: faker.number.int({ min: 10, max: 180 }),
        };
    });

    return {
        transactions,
        alerts,
    };
};
